<template>
    <Loading v-if="!isLoaded" color="black" />
    <slot v-if="isLoaded" />
</template>

<script lang="ts">
    import { computed, defineComponent, onBeforeMount, onBeforeUnmount } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { useStore } from '@/store';
    import { SemboUser } from '@/api/Members/members.interfaces';
    import { endpoints } from '@/api/endpoints';
    import Loading from '@ui/components/Loading/Loading.vue';

    export interface SemboAuth {
        user: SemboUser | null;
    }

    export default defineComponent({
        name: 'AuthProvider',
        methods: { t },
        components: { Loading },
        setup() {
            const store = useStore();

            const isLoaded = computed<boolean>(() => store.getters['auth/getIsLoaded']);

            onBeforeMount(async () => {
                loadSemboUser();

                window.addEventListener('semboUserLoggedIn', semboUserLoggedIn);
            });

            onBeforeUnmount(() => {
                window.removeEventListener('semboUserLoggedIn', semboUserLoggedIn);
            });

            const semboUserLoggedIn = (event: Event) => {
                const customEvent = event as CustomEvent<SemboAuth>;
                setUserSuccess(customEvent.detail?.user);
            };

            const setUserLoading = () => {
                store.dispatch('auth/setUserLoading');
            };

            const setUserError = () => {
                store.dispatch('auth/setUserError');
            };

            const setUserSuccess = (data: SemboUser | null) => {
                store.dispatch('auth/setUserSuccess', data);
            };

            async function loadSemboUser() {
                try {
                    setUserLoading();
                    const response = await endpoints.members.GetMember();
                    setUserSuccess(response);
                } catch {
                    setUserError();
                }
            }

            return { isLoaded };
        },
    });
</script>
